export class ProductGroup {
    public id;
    public name = '';
}
  